import { Spinner } from '@heroui/react';

interface LoaderProps {
  fullScreen?: boolean;
}

export const Loader = ({ fullScreen = true }: LoaderProps) => {
  return (
    <div
      className={`flex w-full items-center justify-center bg-transparent ${fullScreen ? 'h-screen' : 'h-auto py-12'}`}
    >
      <Spinner size="lg" color="accent" />
    </div>
  );
};
